import React, { Children } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/ui/Footer';
import { Award, Briefcase, GraduationCap } from 'lucide-react';
import { motion } from 'framer-motion';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 20
  },
  animate: {
    opacity: 1,
    y: 0
  },
  transition: {
    duration: 0.6
  }
};
const staggerContainer = {
  animate: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
export function TeamPage() {
  const teamMembers = [{
    name: 'Brigitte Tebow',
    role: 'CEO & Founder',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pxTQboBiYT6zUc74QDizUK/Brigitte_Tebow_%281%29.jpg',
    bio: 'Brigitte is a high-impact advisor and speaker who delivers premium insights at enterprise scale—trusted by clients who value speed, precision, and successful outcomes. With a proven track record of leading high-stakes engagements, she is most often called upon by C-suite and senior leaders to accelerate transformation and align complex data ecosystems with business objectives.',
    expertise: [{
      icon: Award,
      title: 'Enterprise Data Strategist & Innovator',
      description: 'Her deep expertise spans Cloud Data Strategy, Master & Reference Data Management (MDM/RDM), Enterprise Data Governance, Data Cataloging, and the advancement of Data Stewardship programs. These skills are at the core of her work with IIA clients, many of whom return for multiple phases of advisory due to measurable success and strategic alignment. As the Founder and CEO of Healthcare MDM, Brigitte brings a specialized lens to U.S. healthcare data.'
    }, {
      icon: Briefcase,
      title: 'Product Expert',
      description: 'Brigitte brings deep subject matter expertise across leading MDM and governance platforms, including Profisee, Ataccama, Gaine, Verato, Collibra, and Microsoft Purview. She also has extensive experience negotiating and operationalizing enterprise data subscription services.',
      platforms: ['Profisee', 'Ataccama', 'Gaine', 'Verato', 'Collibra', 'Microsoft Purview', 'LexisNexis', 'Smarty', 'Melissa', 'ESRI', 'Dun & Bradstreet', 'NPPES', 'Wolters Kluwer', 'USPS', 'Definitive Healthcare', 'AMA', 'Baton', 'Veritas']
    }]
  }, {
    name: 'Kristine Forcadela',
    role: 'Senior Executive Assistant',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2X61ceRFwfyF7pgKU7RkV2/Kristine_Forcadela.jpg',
    bio: 'Senior Executive Assistant supporting enterprise operations and client engagement.'
  }, {
    name: 'Kendra Zigler',
    role: 'Executive Assistant',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uTrpbUqFBm4VQsR2kqbH2d/Kendra_Zigler.jpg',
    bio: 'Executive Assistant supporting day-to-day operations and client coordination.'
  }];
  return <div className="bg-black min-h-screen" data-id="element-329">
      <Header data-id="element-330" />
      <main className="pt-32 pb-24 px-6" data-id="element-331">
        <div className="max-w-7xl mx-auto" data-id="element-332">
          <motion.div className="mb-16 text-center" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-333">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-medium text-white mb-6 font-roboto-condensed" data-id="element-334">
              Our Team
            </h1>
            <p className="text-xl text-white/80 max-w-3xl mx-auto leading-relaxed" data-id="element-335">
              Led by enterprise data strategists with proven expertise in
              healthcare data management.
            </p>
          </motion.div>
          <motion.div className="space-y-16" variants={staggerContainer} initial="initial" animate="animate" data-id="element-336">
            {teamMembers.map(member => <motion.div key={member.name} variants={fadeInUp} className="bg-gradient-to-br from-purple-500/10 to-cyan-500/10 border border-white/10 rounded-3xl p-8 lg:p-12 hover:border-white/20 transition-colors" data-id="element-337">
                <div className="flex flex-col lg:flex-row gap-8 items-start" data-id="element-338">
                  <motion.img src={member.image} alt={member.name} className="w-48 h-48 rounded-2xl object-cover flex-shrink-0" whileHover={{
                scale: 1.05
              }} transition={{
                duration: 0.3
              }} data-id="element-339" />
                  <div className="flex-1" data-id="element-340">
                    <h2 className="text-3xl font-semibold text-white mb-2 font-roboto-condensed" data-id="element-341">
                      {member.name}
                    </h2>
                    <p className="text-xl text-purple-400 mb-6" data-id="element-342">
                      {member.role}
                    </p>
                    <div className="space-y-6 text-white/80 leading-relaxed" data-id="element-343">
                      <p data-id="element-344">{member.bio}</p>
                      {member.expertise && <motion.div className="space-y-4" variants={staggerContainer} data-id="element-345">
                          {member.expertise.map((item, idx) => <motion.div key={idx} variants={fadeInUp} className="bg-black/30 border border-white/10 rounded-xl p-6 hover:bg-black/40 transition-colors" data-id="element-346">
                              <div className="flex items-center gap-3 mb-4" data-id="element-347">
                                <item.icon className="w-6 h-6 text-purple-400" data-id="element-348" />
                                <h3 className="text-xl font-semibold text-white font-roboto-condensed" data-id="element-349">
                                  {item.title}
                                </h3>
                              </div>
                              <p className="text-white/70 mb-4" data-id="element-350">
                                {item.description}
                              </p>
                              {item.platforms && <div className="flex flex-wrap gap-2" data-id="element-351">
                                  {item.platforms.map(platform => <span key={platform} className="px-3 py-1 bg-white/10 rounded-full text-sm text-white/80 hover:bg-white/20 transition-colors" data-id="element-352">
                                      {platform}
                                    </span>)}
                                </div>}
                            </motion.div>)}
                        </motion.div>}
                    </div>
                  </div>
                </div>
              </motion.div>)}
          </motion.div>
        </div>
      </main>
      <Footer data-id="element-353" />
    </div>;
}